import { Relation } from './relation.model';

export class Supplier extends Relation {

}
